import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { Datetime } from '@flipster/react/design-utils/datetime';
import { useResponsive } from '@flipster/react/misc/responsive/legacy';
import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';
import ChevronRightIcon from '@flipster/ui/assets/svgs/chevron-right.svg';
import { DateFormatter } from '@flipster/utils/datetime';

import { competitionBunja, registerCompetitionBunja } from '../bunja';

export const RegisterNowButton = () => {
  const t = useTranslations();
  const { register, isRegistrationPendingAtom } = useBunja(registerCompetitionBunja);
  const { competitionAtom, registrationStatusAtom } = useBunja(competitionBunja);
  const isRegistrationPending = useAtomValue(isRegistrationPendingAtom);
  const competition = useAtomValue(competitionAtom);
  const registrationStatus = useAtomValue(registrationStatusAtom);

  const { isTablet, isDesktop } = useResponsive();
  const isLargerThanTablet = isTablet || isDesktop;

  const isShowRegisterBy = !registrationStatus?.isEnd && !competition?.participationTime;

  if (!isLargerThanTablet)
    return (
      <div className={wrapperCss}>
        <Button withSpinner onClick={register} label={t('Autogen_common.r251126.s_Register_Now')} css={{ w: '100%' }} />
        {isShowRegisterBy && (
          <p className={css({ textStyle: 'Text/L/Regular' })}>
            by{' '}
            <Datetime
              value={competition?.registrationEndTime}
              format={DateFormatter.ShortYearDateTime}
              isUTC
              withUTCText
            />
          </p>
        )}
      </div>
    );

  return (
    <div className={wrapperCss}>
      <button
        type='button'
        onClick={register}
        className={center({
          pos: 'relative',
          w: 472,
          h: '100%',
          color: 'content.default.level-5',
          bg: '#23539e', // legacy BLUE_DARK. should be changed
          textAlign: 'left',
        })}
        disabled={isRegistrationPending}
      >
        <div>
          <span className={css({ textStyle: 'Title/M' })}>
            <FormattedMessage id='Autogen_common.r251126.s_Register_Now' />
          </span>
          {isShowRegisterBy && (
            <p className={css({ textStyle: 'Text/L/Regular' })}>
              by{' '}
              <Datetime
                value={competition?.registrationEndTime}
                format={DateFormatter.ShortYearDateTime}
                isUTC
                withUTCText
              />
            </p>
          )}
        </div>
        <ChevronRightIcon
          className={css({
            pos: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            right: 30,
          })}
          height={22}
          width={22}
        />
      </button>
    </div>
  );
};

const wrapperCss = center({
  flexDir: 'column',
  gap: 4,
  tabletDown: {
    gap: 8,
    p: 30,
    bg: 'gray.black',
  },
});
